var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TestLayout',{attrs:{"title":"FreePlanFooter"}},[_c('span',{staticClass:"color-gray-800 fs-14"},[_vm._v("Since footer is fixed element, it will be displayed at the bottom of the page.")]),_c('FreePlanFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }